import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';

// Config de producción daisies-70154 (misma que landing/consulta).
const firebaseConfig = {
  apiKey: "AIzaSyAysU3cfGKC1Ogii173gO1zNaAQOsizTJQ",
  authDomain: "daisies-70154.firebaseapp.com",
  projectId: "daisies-70154",
  storageBucket: "daisies-70154.appspot.com",
  messagingSenderId: "772742382225",
  appId: "1:772742382225:web:47643d98a6f8b0135f3530",
  measurementId: "G-1XNTTQMZCS"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export const auth = getAuth(app);

// Crea la cuenta de Firebase Auth (mismo patrón que landing createDaisUser).
// Devuelve el ID token para usarlo como auth_token en los endpoints de Odoo.
export const registerFirebaseUser = async (email, password) => {
  try {
    const cred = await createUserWithEmailAndPassword(auth, email.toLowerCase().trim(), password);
    const authToken = await cred.user.getIdToken();
    return { success: true, firebaseUid: cred.user.uid, authToken };
  } catch (err) {
    console.error('[registerFirebaseUser] Error:', err?.code, err?.message);
    if (err?.code === 'auth/email-already-in-use') {
      return { success: false, code: 'email-in-use', error: 'Este correo ya está registrado. Usa otro.' };
    }
    if (err?.code === 'auth/invalid-email') {
      return { success: false, code: 'invalid-email', error: 'El formato del correo no es válido.' };
    }
    if (err?.code === 'auth/weak-password') {
      return { success: false, code: 'weak-password', error: 'La contraseña es muy débil. Usa al menos 8 caracteres con letras y números.' };
    }
    if (err?.code === 'auth/network-request-failed') {
      return { success: false, code: 'network', error: 'Sin conexión. Revisa tu red e intenta de nuevo.' };
    }
    return { success: false, code: 'unknown', error: 'No se pudo crear tu cuenta. Intenta de nuevo.' };
  }
};

// Verificar si un email ya está registrado
// Colección: dais_user, campo: email
// Retorna true si está DISPONIBLE (no existe), false si ya existe
export const checkEmailAvailability = async (email) => {
  try {
    console.log('[checkEmailAvailability] Verificando email:', email);
    const usersRef = collection(db, 'dais_user');
    const q = query(usersRef, where('email', '==', email.toLowerCase().trim()));
    const querySnapshot = await getDocs(q);
    const isAvailable = querySnapshot.empty;
    console.log(`[checkEmailAvailability] Email ${email} disponible:`, isAvailable);
    return isAvailable;
  } catch (error) {
    console.error('[checkEmailAvailability] Error:', error);
    return true; // En caso de error, permitir continuar
  }
};

// Verificar si un teléfono ya está registrado
// Colección: dais_user, campo: phone
// IMPORTANTE: el teléfono debe incluir código de país, ej: "+525512345678"
// Retorna true si está DISPONIBLE (no existe), false si ya existe
export const checkPhoneAvailability = async (phone) => {
  try {
    console.log('[checkPhoneAvailability] Verificando teléfono:', phone);
    const usersRef = collection(db, 'dais_user');
    const q = query(usersRef, where('phone', '==', phone.trim()));
    const querySnapshot = await getDocs(q);
    const isAvailable = querySnapshot.empty;
    console.log(`[checkPhoneAvailability] Teléfono ${phone} disponible:`, isAvailable);
    return isAvailable;
  } catch (error) {
    console.error('[checkPhoneAvailability] Error:', error);
    return true; // En caso de error, permitir continuar
  }
};

// Obtener lista de países desde Firebase
// Colección: res_country
// Cada documento tiene: id (numérico de Odoo), code, name, phone_code, sequence
export const getCountriesFromFirebase = async () => {
  try {
    const countriesRef = collection(db, 'res_country');
    const querySnapshot = await getDocs(countriesRef);
    const countries = querySnapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: data.id,           // ID numérico de Odoo - SE ENVÍA A LA API
        firestoreId: doc.id,   // ID de documento Firestore
        code: data.code,       // "MX", "US", etc.
        name: data.name,       // "México", "United States", etc.
        phone_code: data.phone_code, // "+52", "+1", etc.
        sequence: data.sequence || 999
      };
    });
    return countries.sort((a, b) => a.sequence - b.sequence);
  } catch (error) {
    console.error('[getCountriesFromFirebase] Error:', error);
    return [];
  }
};
// Obtener especialidades desde Firebase
// Colección: dais_specialty
// Cada documento tiene: id (odooId), name, emoji, color, accent, duration_id
export const getSpecialtiesFromFirebase = async () => {
  try {
    const specialtiesRef = collection(db, 'dais_specialty');
    const querySnapshot = await getDocs(specialtiesRef);
    return querySnapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: data.id,
        firestoreId: doc.id,
        name: data.name,
        emoji: data.emoji,
        color: data.color,
        accent: data.accent,
        durationId: data.duration_id,
        desc: data.description || ''
      };
    });
  } catch (error) {
    console.error('[getSpecialtiesFromFirebase] Error:', error);
    return [];
  }
};
